// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dialog-footer[data-v-6136585a] {\n  display: inline-flex;\n  gap: 8px;\n}\ncode[data-v-6136585a] {\n  background: #f2f2f2;\n  padding: 2px 6px;\n  border-radius: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
